import React, { useState, useRef } from 'react'
import moment from 'moment'
import { FormControl, Typography, TextField, Box, Popover, IconButton, Button, Grid, Select, MenuItem, InputAdornment, FormControlLabel, RadioGroup, Radio } from '@mui/material';
import { ReactComponent as DropDownIcon } from "../../../assets/icons/icon-angle-down.svg"
import { makeStyles } from '@mui/styles'
import DatePicker from "react-datepicker";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/icon_calender.svg";
import Controls from '../../controls/Controls';
import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";


const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: "10%",
        width: "100"
    },
    graphFiltergrid: {
        [theme.breakpoints.down('sm')]: {
            marginTop: '0rem',
            '& > .MuiGrid-item': {
                paddingTop: 0,
            },
        },
    },
    inputLabel: {
        minHeight: '21px',
    }
}))

export default function FilterDateRangeView({ obj, i, handleDateFilter, reportIndex, showLabel = true, handleTimePeriodFilter }) {
    const classes = useStyles();
    const [filterInputEl, setFilterInputEl] = React.useState(null);
    const [filterInputOpen, setFilterInputOpen] = React.useState(false);
    const filterInputId = filterInputOpen ? 'simple-popover' : undefined;
    const selectFiltersInput = useRef(null);
    const [selectFilterWidth, setSelectFilterWidth] = useState('200px');
    const [filterDateRangeLabel, setFilterDateRangeLabel] = useState(null);
    const [timePeriodValue, setTimePeriodValue] = useState(null);
    const [filterLabelValue, setFilterLabelValue] = useState(null);


    React.useEffect(() => {
        if (obj?.dateFilterProps?.dateSelectType === 'TIME_PERIOD') {
            setFilterLabelValue('Time Period');
        } else if (obj?.dateFilterProps?.dateSelectType === 'DATE_RANGE') {
            setFilterLabelValue('Select Date Range');
        }
        //console.log(obj)
    }, [obj]);


    const handleFilterInputClick = (event) => {
        //setSelectFilterWidth(selectFiltersInput.current.clientWidth);
        if (event.currentTarget != filterInputEl) {
            setFilterInputEl(event.currentTarget);
        }
        if (!filterInputOpen) {
            setFilterInputOpen(true);
        } else {
            setFilterInputOpen(false);
        }
    };
    const handleFilterInputClose = () => {
        setFilterInputEl(null);
        setFilterInputOpen(false);
    };

    const resetForm = () => {
        if (obj?.dateFilterProps?.dateSelectType === 'TIME_PERIOD') {
            setFilterLabelValue('Time Period');
        }
        else if (obj?.dateFilterProps?.dateSelectType === 'DATE_RANGE') {
            setFilterLabelValue('Select Date Range');
        }
        else {
            setFilterLabelValue('Null')
        }

        setFilterDateRangeLabel(null);
        setTimePeriodValue(null)
        handleDateFilter('', obj, i, 'startDate', reportIndex);
        handleDateFilter('', obj, i, 'endDate', reportIndex);
    }

    const applyForm = () => {
        let value;
        if (obj && obj?.dateFilterProps && (obj?.dateFilterProps?.dateSelectType === 'TIME_PERIOD') && timePeriodValue) {
            value = timePeriodValue ?? 'Time Period';
            handleTimePeriodFilter(timePeriodValue, obj, i, 'inDateRange', reportIndex)
        }
        else {
            if (obj?.values && obj?.values?.length && obj?.values?.[0] && obj?.values?.[1]) {
                value = moment(obj?.values[0]).format('DD/MMM/yyyy') + ' - ' + moment(obj?.values[1]).format('DD/MMM/yyyy');
                setFilterDateRangeLabel(value);
            }
        }
        setFilterLabelValue(value)
        handleFilterInputClose();
    }

    const MultiSelectRow = ({ index, style, data }) => {
        const item = data[index];
        return <div style={style} key={item}>
            <FormControlLabel style={{padding: '0 16px', width: '100%'}} title={item} className="menu-item menu-item-light" label={item}
                control={<Radio className="form_checkbox" size="small"
                    checked={timePeriodValue === item}
                    value={item}
                    onChange={(e) => setTimePeriodValue(e.target.value)} />} />
        </div>
    }


    return (
        <>

            <FormControl variant="outlined" sx={{ width: '100%' }} size="small">
                {showLabel ? <Typography className={classes.inputLabel + " report-form-label"} variant="subtitle1" > {obj?.displayName} </Typography> : null}

                <Box className={`select_filters_input border-input ` + (obj?.values && obj?.values?.length && obj?.values?.[0] && obj?.values?.[1] ? `has-value ` : ` `) + (filterInputOpen ? `has-expanded ` : ` `)} onClick={handleFilterInputClick} ref={selectFiltersInput} >
                    <Box className="select_filters_input_item" display="flex" alignItems="center">
                        <Typography variant="body2" className="label-font">
                            {/*console.log(filterLabelValue,obj, "::filterLabelValue")*/}

                            {/* {
                            obj?.values && obj?.values?.length && obj?.values?.[0] && obj?.values?.[1] ? (
                            `${obj?.values?.[0] ? moment(obj?.values[0]).format('DD/MMM/yyyy') : ''} 
                            ${obj?.values?.[1] ? ' - '+ moment(obj?.values[1]).format('DD/MMM/yyyy') : ''}`
                            ) : 'Select Date Range'
                        } */}
                            {
                                filterLabelValue ?? 'Select'
                            }
                        </Typography>
                    </Box>
                    <Box className="select_filters_end_dropdown_icon"><DropDownIcon className="cr-form-date-icon" /></Box>
                </Box>
                <Popover
                    id={filterInputId}
                    open={filterInputOpen}
                    anchorEl={filterInputEl}
                    onClose={handleFilterInputClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    PaperProps={{
                        classes: {
                            root: 'filter-item-options'
                        }
                    }}
                >
                    <Box className="filters-dropdown-item"
                    //sx={{ width: selectFilterWidth }}
                    >

                        {
                            (obj && obj?.dateFilterProps && obj?.dateFilterProps?.dateSelectType === 'TIME_PERIOD' && obj?.dateFilterProps?.timePeriod?.length > 0) ?
                                <Grid  pt={1}>
                                    <RadioGroup name="controlled-radio-buttons-group" value={""} onChange={(e) => setTimePeriodValue(e.target.value)} >
                                        <div className={`virtual-filter-div ` + ((obj?.dateFilterProps?.timePeriod?.length) ? 'filter-data-exists' : ``)}>
                                            <AutoSizer>
                                                {({ height, width }) => (
                                                    <FixedSizeList
                                                        className="List"
                                                        height={obj?.dateFilterProps?.timePeriod?.length ? height : 20}
                                                        itemCount={obj?.dateFilterProps?.timePeriod?.length}
                                                        width={width - 6}
                                                        itemData={obj?.dateFilterProps?.timePeriod}
                                                        itemSize={35}
                                                    >
                                                        {MultiSelectRow}
                                                    </FixedSizeList>
                                                )}
                                            </AutoSizer>
                                        </div>
                                    </RadioGroup>


                                </Grid>

                                : null
                        }

                        {

                            ((obj?.dateFilterProps && timePeriodValue === 'Custom') || obj?.dateFilterProps?.dateSelectType === 'DATE_RANGE') ?
                                <Box className="filters-dropdown-item-content" sx={{ p: '1.25rem !important' }}>
                                    <Grid container spacing={2} >
                                        <Grid xs={12} md={6} item >
                                            <Typography className="report-form-label" variant="subtitle2" >Start Date</Typography>
                                            <DatePicker
                                                autoComplete='off'
                                                showTimeSelect={(obj?.dateFilterProps && obj?.dateFilterProps?.dateRangeType === "dateTime") ? true : false}
                                                dateFormat="dd-MM-yyyy"
                                                showYearDropdown={true}
                                                showMonthDropdown={true}
                                                dropdownMode="select"
                                                className="report_form_ui_input_date er-input-filter" selected={obj?.values[0] ? new Date(obj?.values[0]) : null} onChange={(e) => handleDateFilter(e, obj, i, 'startDate', reportIndex)}
                                                maxDate={new Date()}
                                                isClearable placeholderText='Select Date'
                                                customInput={
                                                    <TextField className={`report_form_ui_input_date er-input-filter ` + (obj?.values[0] ? `has-value` : ``)}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="start">
                                                                    <CalendarIcon />
                                                                </InputAdornment>
                                                            ),
                                                        }} />
                                                }
                                            />
                                        </Grid>
                                        <Grid xs={12} md={6} item >
                                            <Typography className="report-form-label" variant="subtitle2" >End Date</Typography>
                                            <DatePicker
                                                autoComplete='off'
                                                dateFormat="dd-MM-yyyy"
                                                showYearDropdown={true}
                                                showMonthDropdown={true}
                                                dropdownMode="select"
                                                showTimeSelect={(obj?.dateFilterProps && obj?.dateFilterProps?.dateRangeType === "dateTime") ? true : false}
                                                maxDate={new Date()}
                                                minDate={new Date(obj?.values[0])}
                                                className="report_form_ui_input_date er-input-filter" selected={obj?.values[1] ? new Date(obj?.values[1]) : null} onChange={(e) => handleDateFilter(e, obj, i, 'endDate', reportIndex)}
                                                isClearable placeholderText='Select Date'
                                                customInput={
                                                    <TextField className={`report_form_ui_input_date er-input-filter ` + (obj?.values[1] ? `has-value` : ``)}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="start">
                                                                    <CalendarIcon />
                                                                </InputAdornment>
                                                            ),
                                                        }} />
                                                }
                                            />
                                        </Grid>
                                    </Grid>

                                </Box>
                                : null
                        }

                        {
                            timePeriodValue !== 'Custom' && obj?.dateFilterProps?.dateSelectType !== 'DATE_RANGE' ?
                                <Grid item xs={12} className="filters-popover-footer">
                                    <Box sx={{ mt: 2 }} display="flex" justifyContent='flex-end'>
                                        <Controls.Button className="report_form_ui_btn cancel cancel2 mr-2" color="secondary" text="Clear All" onClick={resetForm} />
                                        <Controls.Button className="report_form_ui_btn submit submit2" type="submit" text="Apply" onClick={applyForm} />
                                    </Box>
                                </Grid> : null
                        }

                    </Box>
                </Popover>
            </FormControl>

        </>
        // <Select onChange={ e => handleTimePeriodFilter(e, obj, i, 'inDateRange', reportIndex)} value={obj?.dateFilterProps?.selectedTimePeriod}>
        //     { (obj?.dateFilterProps?.dateSelectType === 'TIME_PERIOD' && obj?.dateFilterProps?.timePeriod?.length ) ? obj?.dateFilterProps?.timePeriod?.map( (period,index) => (
        //         <MenuItem key={index} value={period} >{period}</MenuItem>
        //     )) : null} 
        // </Select>

    )
}
